var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.218,
    height: 70.911,
    viewBox: "0 0 74.218 70.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(-1530.054 -604.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "blob_1_",
    "data-name": "blob (1)",
    d: "M-22.646-66.406c4.2,3.543,7.553,7.506,12.635,11.936,5.035,4.429,11.8,9.278,13.94,15.386C6.074-32.93,3.6-25.61-.919-20.2-5.4-14.793-11.876-11.343-18.263-8.546c-6.387,2.844-12.588,5.035-17.9,3.4-5.268-1.632-9.6-7.18-15.2-10.444s-12.5-4.243-15.712-8.019c-3.217-3.73-2.8-10.211-1.259-15.805s4.1-10.35,6.014-16.318c1.958-5.968,3.264-13.148,7.367-16.738S-44-76.057-37.985-74.518A39.666,39.666,0,0,1-22.646-66.406Z",
    transform: "translate(1599.559 680.018)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "undraw_empty_re_opql",
    transform: "translate(1536.858 614.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M543.77,314.165a2.265,2.265,0,0,0-1.526-2.493L511,301.266a2.266,2.266,0,0,0-.931-.107l-7.831.741-4.493.426-8.292.784a2.272,2.272,0,0,0-2.027,1.9l-4.21,26.3a2.281,2.281,0,0,0,1.424,2.475l31.57,12.186a2.2,2.2,0,0,0,.459.123,2.263,2.263,0,0,0,.691.005l20.4-3.023a2.261,2.261,0,0,0,1.912-1.9Z",
    transform: "translate(-483.187 -295.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M489.623,336.2l31.569,12.185a.285.285,0,0,0,.145.017l20.4-3.023a.281.281,0,0,0,.24-.239l4.1-27.006a.287.287,0,0,0-.19-.312l-.21-.071L514.64,307.421a.213.213,0,0,0-.044-.011.28.28,0,0,0-.073,0l-19.1,1.807-1.516.142a.287.287,0,0,0-.252.237l-4.209,26.3A.285.285,0,0,0,489.623,336.2Z",
    transform: "translate(-487.455 -300.072)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M508.282,309.214l19.1-1.807a.283.283,0,0,1,.073,0,.212.212,0,0,1,.044.011l31.035,10.332-8.187.867-3.064.323-8.718.921a.615.615,0,0,1-.076,0l-.05-.014Z",
    transform: "translate(-500.314 -300.072)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M484.636,333.785l31.569,12.185a2.133,2.133,0,0,0,.46.121,2.293,2.293,0,0,0,.691.009l20.4-3.023a2.265,2.265,0,0,0,1.914-1.906l4.1-27.007a2.282,2.282,0,0,0-.133-1.18c-.021-.05-.042-.1-.066-.147a2.219,2.219,0,0,0-.719-.856,2.265,2.265,0,0,0-.608-.31l-.037-.013L511,301.265a2.843,2.843,0,0,0-.39-.095,2.251,2.251,0,0,0-.544-.011l-7.83.738-4.493.429-8.294.783a2.252,2.252,0,0,0-.958.317.422.422,0,0,0-.064.039.38.38,0,0,0-.041.031,2.27,2.27,0,0,0-.961,1.512l-4.213,26.3A2.284,2.284,0,0,0,484.636,333.785Zm3.347-28.686a1.683,1.683,0,0,1,.4-.848,1.474,1.474,0,0,1,.214-.209,1.688,1.688,0,0,1,.738-.344,1.275,1.275,0,0,1,.162-.023l13.964-1.319,6.656-.633c.045-.005.086,0,.128-.007a1.59,1.59,0,0,1,.3.022,1.319,1.319,0,0,1,.268.064l31.242,10.406.071.026a1.7,1.7,0,0,1,1.078,1.841l-4.1,27.009a1.7,1.7,0,0,1-1.431,1.429l-20.4,3.023a1.719,1.719,0,0,1-.864-.1l-31.57-12.182a1.715,1.715,0,0,1-1.066-1.856Z",
    transform: "translate(-483.184 -295.8)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M499.319,308.587a.278.278,0,0,1,.085-.123.329.329,0,0,1,.041-.028c.013-.005.027-.013.04-.019a.278.278,0,0,1,.2,0l.657.232,32.1,11.324,7.513-.794,4.2-.443,8.9-.942.8-.083.155-.017a.287.287,0,0,1,.3.207.226.226,0,0,1,.008.045.283.283,0,0,1-.175.293.315.315,0,0,1-.078.021l-1.082.113-8.763.926-3.064.323-8.718.921a.608.608,0,0,1-.076,0l-.05-.014L499.6,308.991l-.111-.039a.212.212,0,0,1-.07-.039A.289.289,0,0,1,499.319,308.587Z",
    transform: "translate(-494.186 -300.749)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M588.405,376.012a.284.284,0,0,1-.236-.322l4.609-30.583a.284.284,0,0,1,.323-.238h0a.284.284,0,0,1,.236.322l-4.609,30.583a.284.284,0,0,1-.323.238Z",
    transform: "translate(-554.837 -325.638)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M619.126,371.248l-3.065.323,3.585-30.329s4.094-.741,4.2-.444C623.917,340.975,619.156,371.053,619.126,371.248Z",
    transform: "translate(-573.877 -322.814)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M331.073,182.533l-.083,13.831,24.485,9.33,8.793-11.811Z",
    transform: "translate(-325.766 -174.331)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M601.034,301.263a1.683,1.683,0,0,0-.793-.551L569,290.306a1.621,1.621,0,0,0-.269-.066,1.584,1.584,0,0,0-.3-.023l.051-.317.313-.226,7.419-5.371,24.776,7.593.043,8.588Z",
    transform: "translate(-541.367 -284.304)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M502.708,380.075a.482.482,0,0,1,.1.022l9.586,3.148a.476.476,0,1,1-.3.905L502.515,381a.476.476,0,0,1,.193-.927Z",
    transform: "translate(-496.154 -349.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M599.361,299.184",
    transform: "translate(-562.478 -294.46)",
    fill: "#d9d9d9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.75cd79ad.svg";
export { ForwardRef as ReactComponent };